import React from "react";
import {  Notification, NotificationGroup, } from "@progress/kendo-react-notification";
import "./notification.scss";


// interface to declare all our prop types
interface Props {
    closable?:boolean;
    children: React.ReactNode;
    onClose?: any;
    position?: any;
    type?: any;
    icon?: boolean;  
  }
  
  const NotificationAlert: React.FC<Props> = ({
    closable,
    children,
    onClose,
    position,
    type,
    icon,
    ...rest
  }) => {

    // const [state, setState] = React.useState({
    //     success: false,
    //     error: false,
    //     warning: false,
    //     info: false,
    //     none: false,
    //   });


    return (
      <div className="notification"> 
        { position && <NotificationGroup
            style={{
              right: 20,
              left: 20,
              top: 20,
              alignItems: "center",
              flexWrap: "wrap-reverse",
            }}
            >
            <Notification closable={closable} type={{  style: "success", icon : true}} onClose={onClose} >
              <span>{children}</span>
            </Notification>
          </NotificationGroup>
        }
        { !position && <NotificationGroup
            style={{
              right: 20,
              left: 20,
              bottom: 20,
              alignItems: "center",
              flexWrap: "wrap-reverse",
            }}
            >
            <Notification closable={closable} type={{  style: type ? type : "success", icon: icon ? icon : true}} onClose={onClose} >
              <span>{children}</span>
            </Notification>
          </NotificationGroup>
        }
      </div>
    );
  };
  
  export default NotificationAlert;


  